import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';

import { PaciensService } from '../../services/paciens.service';
import { PaciensVmForDetail } from '../../models/paciens.model';

@Component({
    selector: 'rendelo-paciens-detail',
    imports: [
        CommonModule,
        MatCardModule,
        MatListModule,
        MatChipsModule,
        MatDividerModule
    ],
    templateUrl: './paciens-detail.component.html'
})
export class PaciensDetailComponent implements OnInit {
    paciens = signal<PaciensVmForDetail | null>(null);
    loading = signal<boolean>(false);
    error = signal<string | null>(null);

    constructor(
        private route: ActivatedRoute,
        private paciensService: PaciensService
    ) { }

    ngOnInit(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.loadPaciens(+id);
        }
    }

    private loadPaciens(id: number): void {
        this.loading.set(true);
        this.error.set(null);

        this.paciensService.getPaciensById(id).subscribe({
            next: (data) => {
                this.paciens.set(data);
                this.loading.set(false);
            },
            error: (err) => {
                this.error.set(err.message || 'Failed to load patient details');
                this.loading.set(false);
            }
        });
    }

    getNemLabel(nem: number): string {
        switch(nem) {
            case 1: return 'Férfi';
            case 2: return 'Nő';
            default: return 'Ismeretlen';
        }
    }
}
